import { Routes } from '@angular/router';

import { SERVICE_ANALYTICS } from '../shared/models/list';

import { BidListComponent } from './components/bid-list/bid-list.component';
import { AuctionDashboardComponent } from './components/dashboard/auction-dashboard.component';
import { AuctionOfferSelectionComponent } from './components/list/auction-offer-selection.component';
import { AuctionOfferBiddingScreenComponent } from './components/list/step-2/auction-offer-bidding-screen.component';
import {
	AuctionOfferConfirmationScreenComponent
} from './components/list/step-3/auction-offer-confirmation-screen.component';
import { auctionOfferResolver } from './resolvers/auction-offer.resolver';

export const routes: Routes = [
	{
		path: '',
		redirectTo: 'dashboard',
		pathMatch: 'full',
		data: { pageName: 'Redirect', service: SERVICE_ANALYTICS.AUCTION }
	},
	{
		path: 'dashboard',
		component: AuctionDashboardComponent,
		data: { pageName: 'Auctions - Dashboard', service: SERVICE_ANALYTICS.AUCTION }
	},
	{
		path: 'bidding',
		children: [
			{
				path: 'offer-selection',
				component: AuctionOfferSelectionComponent,
				data: { pageName: 'Auctions - Offer List', service: SERVICE_ANALYTICS.AUCTION }
			},
			{
				path: 'offer/:offerid/:soldTo',
				resolve: {
					auctionOffer: auctionOfferResolver
				},
				children: [
					{
						path: '',
						component: AuctionOfferBiddingScreenComponent,
						data: { pageName: 'Auctions - Offer Bidding', service: SERVICE_ANALYTICS.AUCTION }
					},
					{
						path: 'confirmation',
						component: AuctionOfferConfirmationScreenComponent,
						data: { pageName: 'Auctions - Bidding Confirmation', service: SERVICE_ANALYTICS.AUCTION }
					}
				]
			}
		]
	},
	{
		path: 'bids',
		component: BidListComponent,
		data: { pageName: 'Auctions - Bids List', service: SERVICE_ANALYTICS.AUCTION }
	}
];
